import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { AppConstants } from '@apps/app.constants';
import { BaseMiscApiService } from '@common/api/base-misc-api.service';

import { EntityFilters } from '../models';
import { EntityFiltersApi } from './models';
import { Result204 } from '@common/api/models/result204';

@Injectable({
    providedIn: 'root'
})
export class EntityFiltersApiService extends BaseMiscApiService
{
    constructor (
        http: HttpClient
    )
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlPrtg;
        this.segmentApi = '/prtg/filters';
    }

    createEntityFilters (entityFilters: EntityFilters): Observable<EntityFiltersApi>
    {
        return this.post<EntityFiltersApi>(`/${entityFilters.entityId}`, entityFilters.filters);
    }

    retrieveEntityFilters (entityId: string): Observable<Result204<EntityFiltersApi>>
    {
        // entityId = 'dlz9c117-28af-e711-80d0-005056ae7252';
        return this.getNoContent<EntityFiltersApi>(`/${entityId}`, new EntityFilters(entityId, []));
    }

    updateEntityFilters (entityFilters: EntityFilters): Observable<EntityFiltersApi>
    {
        return this.patch<EntityFiltersApi>(`/${entityFilters.entityId}`, entityFilters.filters);
    }

    deleteEntityFilters (entityId: string): Observable<boolean>
    {
        return this.delete(`/${entityId}`);
    }
}
